import { render, staticRenderFns } from "./storeTop.vue?vue&type=template&id=177507b6&scoped=true"
import script from "./storeTop.vue?vue&type=script&lang=js"
export * from "./storeTop.vue?vue&type=script&lang=js"
import style0 from "./storeTop.vue?vue&type=style&index=0&id=177507b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177507b6",
  null
  
)

export default component.exports